<!-- HEADER -->
<app-screen-heading [title]="'Undertakings'" [hideButtonsOnSmallScreen]="false" [hideBottomBorder]="false">
    <!-- <ng-container smallScreenButtons>
        <button mat-menu-item>
        <span class="text">Add BU</span>
        </button>
        <button mat-menu-item >
        <span class="text">Upload New</span>
        </button>
    </ng-container>
    
    <ng-container regularButtons>
        <button class="btn">
        <span class="text">Add BU</span>
        <img src="assets/images/icons/add-w.svg" alt="Add icon">
        </button>
        <button class="btn btn-outline">
        <span class="text">Upload New</span>
        <img src="assets/images/icons/upload.svg" alt="Upload icon">
        </button>
    </ng-container> -->
    </app-screen-heading>
    
    <!-- FILTERS -->
    <app-table-filter
    [showSearch]="true"
    [searchPlaceholder]="'Search by Name'"
    (filterChange)="handleChangeFilter($event)">
    </app-table-filter>
    
    <div class="page-table">
        <table>
            <thead>
                <tr class="header-columns">
                    <td><span>Name</span></td>
                    <td><span>Longitude</span></td>
                    <td><span>Latitude</span></td>
                    <td><span>Address</span></td>
                </tr>
            </thead>
            
            <tbody>
                <tr *ngFor="let item of businessUnits" class="bodyRow clickable actions-click" [ngClass]="{'selected': selectedBU.id===item.id}" (click)="selectBU(item.id)">
                    <td><span>{{item.name | hasValue}}</span></td>
                    <td><span>{{item.longitude | hasValue}}</span></td>
                    <td><span>{{item.latitude | hasValue}}</span></td>
                    <td><span>{{item.address | hasValue}}</span></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="pagination-wrapper">
        <app-pagination
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        [count]="count"
        (pageChange)="pageChange($event)"
        >
        </app-pagination>